import React, { useState } from "react";

export default function Maplee() {
  const images = [`${process.env.PUBLIC_URL}/Maplee-Open-Graph.avif`];

  const screenshots = [
    {
      title: "Home Page",
      image: `${process.env.PUBLIC_URL}/maplee-current-1.avif`,
    },
    {
      title: "All Products Page",
      image: `${process.env.PUBLIC_URL}/maplee-current-2.avif`,
    },
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const isMobile = window.innerWidth < 768;

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % screenshots.length);
  };

  const prevPage = () => {
    setCurrentPage((prev) =>
      prev === 0 ? screenshots.length - 1 : prev - 1
    );
  };

  return (
    <div className="flex flex-col">
      {/* 🔹 Top Section */}
      <div
        className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 py-20 "
        style={{ 
          backgroundImage: `url(${process.env.PUBLIC_URL}/${
            isMobile ? "Grid-3-mobile.webp" : "Grid-3.webp"
          })`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: isMobile ? "scroll" : "fixed",
        }}
      >
        <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-8 pt-20">
          <div className="w-full hidden md:flex justify-center items-stretch">
            <img
              src={images[0]}
              alt="Maplee – Canada’s All-Canadian Marketplace"
              className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
            />
          </div>

          <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
            <h1 className="text-4xl font-bold text-purple-400 mb-6">
              Maplee – Co-Founding Engineer
            </h1>

            <p className="text-gray-300 leading-relaxed text-lg mb-6">
              Maplee is Canada’s first all-Canadian multi-vendor marketplace built
              to empower independent brands and local retailers. As Co-Founding
              Engineer, I led the technical architecture, full-stack development,
              and product strategy from the ground up.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg mb-6">
              I designed and built the platform using modern web technologies,
              implementing vendor onboarding systems, product management
              workflows, custom UI components, secure authentication, and
              scalable database structures. I also architected role-based access
              controls, optimized performance, and structured the system for
              long-term scalability.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg mb-6">
              Beyond development, I contributed to brand positioning, vendor
              acquisition strategy, SEO optimization, and analytics tracking —
              aligning technical decisions with real business growth.
            </p>

            <h2 className="text-2xl font-semibold text-purple-300 mb-4">
              Maplee represents my ability to:
            </h2>

            <ul className="list-disc list-outside pl-6 text-left text-gray-300 text-md md:text-lg space-y-4">
              <li>Build production-level full-stack systems</li>
              <li>
                Translate business requirements into scalable technical solutions
              </li>
              <li>Think like both an engineer and a founder</li>
              <li>Lead product development from concept to launch</li>
            </ul>
          </div>
        </div>
      </div>

      {/* 🔹 Screenshot Slider Section */}
      <div
        className="min-h-screen flex flex-col items-center justify-center bg-gray-800 text-white px-4 md:px-8 pt-10"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/BG3.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2 className="text-3xl font-bold text-purple-300 mb-6">
          Home Page / All Products Page
        </h2>

        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg max-w-4xl w-full text-center mb-20">
          <h3 className="text-3xl font-bold mb-6">
            {screenshots[currentPage].title}
          </h3>

          <img
            src={screenshots[currentPage].image}
            alt={screenshots[currentPage].title}
            className="w-full max-h-full object-contain rounded-xl mx-auto"
          />

          <div className="mt-6 flex justify-between">
            <button
              onClick={prevPage}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 rounded-full transition"
            >
              ← Previous
            </button>

            <button
              onClick={nextPage}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 rounded-full transition"
            >
              Next →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}